import Vue from 'vue'
import Vuex from 'vuex'

import appConfig from './modules/appConfig'
import axiosConfig from './modules/axiosConfig'
import login from './modules/login'
import logout from './modules/logout'
import dashboard from './modules/dashboard'
import listHolding from './modules/listHolding'
import listCommerce from './modules/listCommerce'
import listCommercial from './modules/listCommercial'
import listCommercialFijo from './modules/listCommercialFijo'
import listUsers from './modules/listUsers'
import listTPV from './modules/listTPV'
import insertUsers from './modules/insertUsers'
import listProfile from './modules/listProfile'
import deleteUsers from './modules/deleteUsers'
import modUsers from './modules/modUsers'
import insertTPVS from './modules/insertTPVS'
import deleteTPVS from './modules/deleteTPVS'
import modTPVS from './modules/modTPVS'
import visorTPVS from './modules/visorTPVS'
import listMovimientos from './modules/listMovimientos'
import tariff from './modules/tariff'
import requests from './modules/requests'
import vendors from './modules/vendors'
import listBilling from './modules/listBilling'
import listFinancing from './modules/listFinancing'
import typeRappel from './modules/typeRappel'
import listNavProfil from './modules/listNavegationProfil'
import insertUsersQr from './modules/insertUsersQr'
import deleteUserQr from './modules/deleteUserQr'
import UpdateUserQr from './modules/UpdateUserQr'
import loyalty from './modules/loyalty'
import loyaltyDetails from './modules/loyaltyDetails'
import loyaltyIdDropdown from './modules/loyaltyIdDropdown'
import loyaltyMovimientos from './modules/loyaltyMovimientos'
import loyaltyCheckId from './modules/loyaltyCheckId'
import loyaltyCreateAccount from './modules/loyaltyCreateAccount'
import loyaltyCupones from './modules/loyaltyCupones'
import loyaltyUpdateClient from './modules/loyaltyUpdateClient'
import loyaltyAnalytics from './modules/loyaltyAnalytics'

export const initialState = {
  appConfig: { ...appConfig.state },
  axiosConfig: { ...axiosConfig.state },
  login: { ...login.state },
  dashboard: { ...dashboard.state },
  logout: { ...logout.state },
  listHolding: { ...listHolding.state },
  listCommerce: { ...listCommerce.state },
  listCommercial: { ...listCommercial.state },
  listCommercialFijo: { ...listCommercialFijo.state },
  listUsers: { ...listUsers.state },
  listTPV: { ...listTPV.state },
  insertUsers: { ...insertUsers.state },
  listProfile: { ...listProfile.state },
  deleteUsers: { ...deleteUsers.state },
  modUsers: { ...modUsers.state },
  insertTPVS: { ...insertTPVS.state },
  deleteTPVS: { ...deleteTPVS.state },
  modTPVS: { ...modTPVS.state },
  visorTPVS: { ...visorTPVS.state },
  listMovimientos: { ...listMovimientos.state },
  tariff: { ...tariff.state },
  requests: { ...requests.state },
  vendors: { ...vendors.state },
  listBilling: { ...listBilling.state },
  listFinancing: { ...listFinancing.state },
  typeRappel: { ...typeRappel.state },
  listNavProfil: { ...listNavProfil.state },
  insertUsersQr: { ...insertUsersQr.state },
  deleteUserQr: { ...deleteUserQr.state },
  UpdateUserQr: { ...UpdateUserQr.state },
  loyalty: { ...loyalty.state },
  loyaltyDetails: { ...loyaltyDetails.state },
  loyaltyIdDropdown: { ...loyaltyIdDropdown.state },
  loyaltyMovimientos: { ...loyaltyMovimientos.state },
  loyaltyCheckId: { ...loyaltyCheckId.state },
  loyaltyCreateAccount: { ...loyaltyCreateAccount.state },
  loyaltyCupones: { ...loyaltyCupones.state },
  loyaltyUpdateClient: { ...loyaltyUpdateClient.state },
  loyaltyAnalytics: { ...loyaltyAnalytics.state }
}

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    isError: false,
    isFatal: false,
    errorMessage: '',
    busy: false,
    mqPhone: window.matchMedia('(max-width: 767px)')
  },
  getters: {
    isError: state => state.isError,
    isFatal: state => state.isFatal,
    errorMessage: state => state.errorMessage,
    isBusy: state => state.busy,
    isMobile: state => state.mqPhone.matches
  },
  mutations: {
    'RESET_STATE' (state) {
      Object.keys(initialState).forEach(key => {
        Object.assign(state[key], initialState[key])
      })
    },

    'SET_ERROR' (state, payload) {
      state.isError = payload.isError
      state.isFatal = payload.isFatal
      state.errorMessage = payload.msg
    },

    'HANDLE_ERROR' (state, payload) {
      switch (payload) {
        case '039':
          state.isError = true
          state.isFatal = true
          state.errorMessage = 'Ha expirado la sesión. Por favor, vuelva a logarse'
          break

        case 200:
          state.isError = true
          state.isFatal = false
          state.errorMessage = 'Error Tecnico del Sistema: Consulte con el administrador.'
          break

        case 220:
          state.isError = true
          state.isFatal = false
          state.errorMessage = 'Error técnico'
          break

        case '019':
          state.isError = true
          state.isFatal = true
          state.errorMessage = 'Usuario o contraseña es incorrecta o no existe'
          break

        case '007':
          state.isError = true
          state.isFatal = true
          state.errorMessage = 'El usuario ya cuenta con una sesión activa'
          break

        case '011':
          state.isError = true
          state.isFatal = true
          state.errorMessage = 'Operación no disponible para el perfil del usuario'
          break

        case '027':
          state.isError = true
          state.isFatal = true
          state.errorMessage = 'Usuario o contraseña es incorrecta o no existe'
          break

        case '028':
          state.isError = true
          state.isFatal = true
          state.errorMessage = 'Fecha de inicio de vigencia de contraseña no cumplida'
          break

        case '029':
          state.isError = true
          state.isFatal = true
          state.errorMessage = 'Contraseña caducada'
          break

        case '035':
          state.isError = true
          state.isFatal = true
          state.errorMessage = 'Tipo y número de documento obligatorio'
          break

        case '041':
          state.isError = true
          state.isFatal = true
          state.errorMessage = 'Superó el número maximo de intentos, contacte con el administrador'
          break

        case 102:
          state.isError = false
          state.isFatal = false
          state.errorMessage = 'No se han encontrado resultados a la búsqueda'
          break

        default:
          state.isError = true
          state.isFatal = false
          state.errorMessage = 'Error desconocido'
      }
    },

    'SET_BUSYNESS' (state, payload) {
      state.busy = payload
    }
  },
  modules: {
    appConfig,
    axiosConfig,
    login,
    dashboard,
    logout,
    listHolding,
    listCommerce,
    listCommercial,
    listCommercialFijo,
    listUsers,
    listTPV,
    insertUsers,
    listProfile,
    deleteUsers,
    modUsers,
    insertTPVS,
    deleteTPVS,
    modTPVS,
    visorTPVS,
    listMovimientos,
    tariff,
    requests,
    vendors,
    listBilling,
    listFinancing,
    typeRappel,
    listNavProfil,
    insertUsersQr,
    deleteUserQr,
    UpdateUserQr,
    loyalty,
    loyaltyDetails,
    loyaltyIdDropdown,
    loyaltyMovimientos,
    loyaltyCheckId,
    loyaltyCreateAccount,
    loyaltyCupones,
    loyaltyUpdateClient,
    loyaltyAnalytics
  }
})
